function convertToPersonalTx(tx, kiosk, kioskOwnerCap, packageId) {
  const personalKioskCap = tx.moveCall({
    target: `${packageId}::personal_kiosk::new`,
    arguments: [tx.object(kiosk), tx.object(kioskOwnerCap)]
  });
  return personalKioskCap;
}
function transferPersonalCapTx(tx, personalKioskCap, packageId) {
  tx.moveCall({
    target: `${packageId}::personal_kiosk::transfer_to_sender`,
    arguments: [personalKioskCap]
  });
}
export {
  convertToPersonalTx,
  transferPersonalCapTx
};
//# sourceMappingURL=personal-kiosk.js.map
